module.exports = __webpack_public_path__ + "img/airplane.8f410173.png";